(() => {
  const menu = document.querySelector('.njb-category-menu');
  if (menu) {
    document.addEventListener('pointerdown', event => { if (!menu.contains(event.target)) menu.open = false; });
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    const active = menu.querySelector('a[aria-current]');
    if (active) menu.querySelector('summary').firstChild.textContent = active.firstChild.textContent.trim() + ' ';
  }
  const links = [...document.querySelectorAll('[data-njb-category]')];
  const current = new URL(location.href);
  const carryKeys = ['filter.p.m.organizer.car_models', 'preview_theme_id', '_fd', 'pb'];
  for (const link of links) {
    const url = new URL(link.href);
    for (const key of carryKeys) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    link.href = url.href;
  }
  async function worker() {
    while (links.length) {
      const link = links.shift();
      const url = new URL(link.href);
      const brand = url.searchParams.get('filter.p.m.organizer.product_brand');
      url.searchParams.set('section_id', 'njt-category-availability');
      try {
        const response = await fetch(url, {signal: AbortSignal.timeout(10000)});
        if (!response.ok) continue;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(doc.querySelector('[data-njt-category-availability]')?.textContent || 'null');
        if (data && data.brand === brand && Number.isInteger(data.count)) link.hidden = data.count === 0;
      } catch (_) {}
    }
  }
  Promise.all([worker(), worker()]);
})();
